import SpacetabUI from '@spacetab-io/vue-components/src';
import Vue, { CreateElement, VNode } from 'vue';
import Gravatar from 'vue-gravatar';
import VModal from 'vue-js-modal';
import VueMeta from 'vue-meta';
import VueSlider from 'vue-slider-component';
import Vuelidate from 'vuelidate';

import App from './App.vue';
import {
  i18n,
} from './plugins/vue-i18n';
import router from './router';
import {
  store,
} from './store';

Vue.use(SpacetabUI);
Vue.use(Vuelidate);
Vue.use(VModal);
Vue.use(VueMeta);

Vue.component('VueSlider', VueSlider);
Vue.component('v-gravatar', Gravatar);

declare module 'vue/types/vue' {
  interface Vue {
    $config: typeof __config;
  }
}
Vue.prototype.$config = __config;

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: (h: CreateElement): VNode => h(App),
}).$mount('#app');
